(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(48233);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.ts + 138 modules
var components = __webpack_require__(36357);
// EXTERNAL MODULE: ./node_modules/toggled/dist/toggled.esm.js
var toggled_esm = __webpack_require__(67866);
// EXTERNAL MODULE: ./src/hooks/index.ts + 31 modules
var hooks = __webpack_require__(81251);
// EXTERNAL MODULE: ./src/hooks/use-vendor.ts
var use_vendor = __webpack_require__(1360);
// EXTERNAL MODULE: ./src/layouts/index.ts + 17 modules
var layouts = __webpack_require__(63409);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(18499);
// EXTERNAL MODULE: ./src/analytics/index.ts + 4 modules
var analytics = __webpack_require__(30588);
// EXTERNAL MODULE: ./src/gql/queries/index.ts + 45 modules
var queries = __webpack_require__(98);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./src/variables.js
var variables = __webpack_require__(93063);
;// CONCATENATED MODULE: ./src/screens/home/banner/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url(",
        ");\n  background-size: 100% 100%;\n  height: calc(100vw / 2);\n  width: 100%;\n\n  ",
        " {\n    background-image: url(",
        ");\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fe60696c-0"
})(_templateObject(), function(props) {
    return props.mobileImage;
}, (0,styled_breakpoints.up)("lg"), function(props) {
    return props.desktopImage;
}, function(props) {
    return props.$isFullWidth ? "height: calc(100vw / 4)" : "height: calc((100vw - ".concat(variables/* dimensions.cartWidth */.MB.cartWidth, "px) / 4)");
});
var Anchor = styled_components_browser_esm/* default.a.attrs */.ZP.a.attrs({
    rel: "noopener noreferrer",
    target: "_blank"
}).withConfig({
    componentId: "sc-fe60696c-1"
})(_templateObject1());
var getOptimizedImages = function(props) {
    var desktopImage = props.desktopImage, mobileImage = props.mobileImage;
    var optimizedImages = {
        desktopImage: utils/* cloudinary.applyTransformations */.nl.applyTransformations(desktopImage, constants/* transformations.DESKTOP_BANNER */.S7.DESKTOP_BANNER),
        mobileImage: utils/* cloudinary.applyTransformations */.nl.applyTransformations(mobileImage, constants/* transformations.MOBILE_BANNER */.S7.MOBILE_BANNER)
    };
    if (!mobileImage) {
        optimizedImages.mobileImage = optimizedImages.desktopImage;
    }
    return optimizedImages;
};
var Banner = function(props) {
    var link = props.link, style = props.style, className = props.className, onRender = props.onRender, isEventSent = props.isEventSent;
    var optimizedImages = getOptimizedImages(props);
    var isFullWidth = (0,toggled_esm/* useFlag */.P5)(constants/* flagQueries.HAS_FULL_WIDTH */.mE.HAS_FULL_WIDTH);
    var onClick = function() {
        return analytics/* analytics.selectPromotion */.co.selectPromotion(constants/* analyticsCreativeSlot.MAIN_BANNERS */.n9.MAIN_BANNERS);
    };
    var ref = (0,react.useRef)(null);
    var isObserved = (0,hooks/* useIntersectionObserver */.S1)(ref, 0.95);
    (0,react.useEffect)(function() {
        if (!isEventSent && isObserved) {
            onRender();
        }
    });
    if (!link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            $isFullWidth: isFullWidth,
            style: style,
            className: className,
            onClick: onClick
        }, optimizedImages), {
            ref: ref
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
        href: link,
        style: style,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            $isFullWidth: isFullWidth,
            onClick: onClick
        }, optimizedImages), {
            ref: ref
        }))
    });
};
/* harmony default export */ var home_banner = (Banner);

;// CONCATENATED MODULE: ./src/screens/home/banners/component.tsx









var Banners = function() {
    var ref;
    var data = (0,react_hooks_esm/* useQuery */.aM)(queries/* bannersQuery */.QJ).data;
    var dataSource = data === null || data === void 0 ? void 0 : (ref = data.vendor) === null || ref === void 0 ? void 0 : ref.banners;
    var ref1 = (0,react.useState)(false), isEventSent = ref1[0], setIsEventSent = ref1[1];
    var onBannerRender = function() {
        analytics/* analytics.viewPromotion */.co.viewPromotion(constants/* analyticsCreativeSlot.MAIN_BANNERS */.n9.MAIN_BANNERS);
        setIsEventSent(true);
    };
    (0,react.useEffect)(function() {
        onBannerRender();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Carousel */.lr, {
        dataSource: dataSource,
        afterSlide: function() {
            return setIsEventSent(false);
        },
        renderer: function(banner) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(home_banner, (0,_object_spread/* default */.Z)({
                onRender: onBannerRender,
                isEventSent: isEventSent
            }, banner), banner.id);
        }
    });
};
/* harmony default export */ var component = (Banners);

;// CONCATENATED MODULE: ./src/screens/home/banners/index.js

/* harmony default export */ var banners = (component);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/screens/home/section/index.tsx
var section = __webpack_require__(27026);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/screens/home/categories-section/category.tsx







function Category(param) {
    var name = param.name, image = param.image, slug = param.slug, encodedId = param.encodedId;
    var vendor = (0,use_vendor/* default */.Z)();
    var hideCategoryName = vendor.settings.hideCategoryName;
    var optimizedImage = utils/* cloudinary.applyTransformations */.nl.applyTransformations(image, constants/* transformations.CATEGORY */.S7.CATEGORY);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)("h-36", image && "bg-center bg-no-repeat", image && hideCategoryName ? "bg-contain" : "bg-cover"),
        style: {
            backgroundImage: image ? "url(".concat(optimizedImage, ")") : undefined
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/c/".concat(slug, "-").concat(encodedId),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (0,clsx/* default */.Z)("flex h-full items-center justify-center p-4 text-xl font-semibold text-white lg:transition-colors lg:hover:bg-black/20", !hideCategoryName && "bg-zinc-800/30"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,clsx/* default */.Z)(hideCategoryName && "invisible"),
                    children: name
                })
            })
        })
    });
}
/* harmony default export */ var categories_section_category = (Category);

;// CONCATENATED MODULE: ./src/screens/home/categories-section/index.tsx












function Categories() {
    var ref;
    var data = (0,react_hooks_esm/* useQuery */.aM)(queries/* categoriesQuery */.BN).data;
    var dataSource = data === null || data === void 0 ? void 0 : (ref = data.vendor) === null || ref === void 0 ? void 0 : ref.categories;
    var isFullWidth = (0,toggled_esm/* useFlag */.P5)(constants/* flagQueries.HAS_FULL_WIDTH */.mE.HAS_FULL_WIDTH);
    var vendor = (0,hooks/* useVendor */.at)();
    var categoriesOrBrandsTitle = "Categor\xedas";
    var categoriesOrBrandsSubtitle;
    if (vendor.settings.categoryAsBrand) {
        categoriesOrBrandsTitle = "Marcas";
        categoriesOrBrandsSubtitle = "\xa1Dale click a las marcas para ver m\xe1s productos!";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(section/* default */.Z, {
        title: categoriesOrBrandsTitle,
        subtitle: categoriesOrBrandsSubtitle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)("grid grid-cols-1 gap-0.5 md:grid-cols-2 md:gap-4 md:px-4", isFullWidth ? "lg:grid-cols-4" : "lg:grid-cols-3"),
            children: (0,lodash.map)(dataSource, function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(categories_section_category, (0,_object_spread/* default */.Z)({}, category), category.id);
            })
        })
    });
}
/* harmony default export */ var categories_section = (Categories);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/hooks/use-scroll-restoration.ts
var use_scroll_restoration = __webpack_require__(57299);
;// CONCATENATED MODULE: ./src/screens/home/featured-products-section/index.js













// FIXME: this logic is used in several places, it should be shared
function productHasStock(product, handlesStock) {
    if (product.variantInStock) {
        return true;
    }
    if (product.stock <= 0) {
        return false;
    }
    var _maximumSalesQuantity;
    var maximumSalesQuantity = (_maximumSalesQuantity = product.maximumSalesQuantity) !== null && _maximumSalesQuantity !== void 0 ? _maximumSalesQuantity : Number.MAX_SAFE_INTEGER;
    var max = handlesStock ? Math.min(product.stock, maximumSalesQuantity) : maximumSalesQuantity;
    var canJumpAtLeastOnce = (0,utils/* validateIfCanJumpOnce */.Xw)(product.jumpFactor, product.minimumSalesQuantity, max);
    return canJumpAtLeastOnce;
}
function FeaturedProducts() {
    var ref, ref1, ref2, ref3;
    var data = (0,react_hooks_esm/* useQuery */.aM)(queries/* featuredProductsQuery */.BP).data;
    var vendor = (0,hooks/* useVendor */.at)();
    var handlesStock = (0,toggled_esm/* useFeature */.SS)(constants/* flags.HANDLE_STOCK */.id.HANDLE_STOCK);
    var ref4;
    // FIXME: control loading states and errors
    var featuredProducts = (ref4 = data === null || data === void 0 ? void 0 : (ref = data.vendor) === null || ref === void 0 ? void 0 : ref.featuredProducts) !== null && ref4 !== void 0 ? ref4 : [];
    (0,use_scroll_restoration/* useScrollRestoration */.p)();
    if ((0,lodash.isEmpty)(featuredProducts)) {
        return null;
    }
    if ((ref1 = vendor.settings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.catalog) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.sortOOOFeaturedProductsLast) {
        // To avoid modifying the original source
        featuredProducts = (0,_to_consumable_array/* default */.Z)(featuredProducts).sort(function(productA, productB) {
            var productAHasStock = productHasStock(productA, handlesStock);
            var productBHasStock = productHasStock(productB, handlesStock);
            if (productAHasStock && !productBHasStock) {
                return -1;
            }
            if (!productAHasStock && productBHasStock) {
                return 1;
            }
            return 0;
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(section/* default */.Z, {
        title: "Productos destacados",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Catalog */.gm, {
            products: featuredProducts
        })
    });
}
/* harmony default export */ var featured_products_section = (FeaturedProducts);

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/truck/icon/index.tsx + 1 modules
var icon = __webpack_require__(63216);
// EXTERNAL MODULE: ./src/truck/new-button/NewButton.tsx + 4 modules
var NewButton = __webpack_require__(8262);
// EXTERNAL MODULE: ./src/screens/repurchase/contents/most-purchased.tsx
var most_purchased = __webpack_require__(6203);
// EXTERNAL MODULE: ./src/screens/repurchase/line-item/index.tsx
var line_item = __webpack_require__(80208);
;// CONCATENATED MODULE: ./src/screens/repurchase/shortcut/index.tsx











function useMostPurchasedProductsQuery() {
    var mostPurchasedQuery = (0,es.useQuery)("/account/purchased-products");
    var catalogParams = (0,most_purchased/* getCatalogParams */.cp)(mostPurchasedQuery);
    var catalogQuery = (0,es.useQuery)([
        "/catalog/products",
        catalogParams
    ], {
        enabled: !!catalogParams
    });
    return {
        mostPurchasedQuery: mostPurchasedQuery,
        catalogQuery: catalogQuery
    };
}
function MostPurchasedPreview(props) {
    var catalogQuery = props.catalogQuery, mostPurchasedQuery = props.mostPurchasedQuery;
    var limit = (0,hooks/* useIsMobile */.dD)() ? 3 : 4;
    var sortedCatalogItems = react.useMemo(function() {
        return (0,lodash.take)((0,lodash.map)((0,most_purchased/* getSortedPairs */.U0)(catalogQuery, mostPurchasedQuery), "product"), limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        catalogQuery.dataUpdatedAt,
        mostPurchasedQuery.dataUpdatedAt,
        limit
    ]);
    if ((0,lodash.isEmpty)(sortedCatalogItems)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-4 bg-white p-2 md:ml-4 md:w-fit",
        children: [
            (0,lodash.map)(sortedCatalogItems, function(catalogProduct) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(line_item/* RepurchaseLineItemImage */.W, {
                    src: catalogProduct.photo,
                    height: theme/* default.spacing.cozy */.Z.spacing.cozy * 6,
                    width: theme/* default.spacing.cozy */.Z.spacing.cozy * 6
                }, catalogProduct.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/mi-cuenta/mas-comprados",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                    variant: "secondary",
                    size: "icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        color: "currentColor",
                        type: "caret-right"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/home/repurchase-section/index.tsx





function RepurchaseSection() {
    var ref;
    var ref1 = useMostPurchasedProductsQuery(), catalogQuery = ref1.catalogQuery, mostPurchasedQuery = ref1.mostPurchasedQuery;
    if ((0,lodash.isEmpty)((ref = catalogQuery.data) === null || ref === void 0 ? void 0 : ref.data)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(section/* default */.Z, {
        title: "Comprar de nuevo",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MostPurchasedPreview, {
            mostPurchasedQuery: mostPurchasedQuery,
            catalogQuery: catalogQuery
        })
    });
}
/* harmony default export */ var repurchase_section = (RepurchaseSection);

// EXTERNAL MODULE: ./src/truck/image/index.tsx
var truck_image = __webpack_require__(52679);
;// CONCATENATED MODULE: ./src/screens/home/tg-quote/index.js








var photos = {
    desktop: utils/* cloudinary.getFullUrl */.nl.getFullUrl("v1533086222/saas/tortas-gaby/banners/quote-desktop.jpg"),
    mobile: utils/* cloudinary.getFullUrl */.nl.getFullUrl("v1533084354/saas/tortas-gaby/banners/quote-mobile.jpg")
};
var optimizedPhotos = {
    desktop: utils/* cloudinary.applyTransformations */.nl.applyTransformations(photos.desktop),
    mobile: utils/* cloudinary.applyTransformations */.nl.applyTransformations(photos.mobile)
};
var Component = function(props) {
    var photo = props.photo, style = props.style, className = props.className;
    var vendor = (0,use_vendor/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: vendor.whatsappUrl,
        style: style,
        className: className,
        rel: "noopener noreferrer nofollow",
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_image/* default */.Z, {
            src: photo,
            style: {
                width: "100%"
            }
        })
    });
};
var TgQuote = function(props) {
    var desktop = optimizedPhotos.desktop, mobile = optimizedPhotos.mobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Media */.pU, {
        desktop: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            photo: desktop
        })),
        mobile: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            photo: mobile
        }))
    });
};
/* harmony default export */ var tg_quote = (TgQuote);

;// CONCATENATED MODULE: ./src/screens/home/index.js













function HomeScreen() {
    var ref, ref1;
    var user = (0,hooks/* useUser */.aF)();
    var allowRepurchaseFF = (0,toggled_esm/* useFlag */.P5)(constants/* flags.ALLOW_REPURCHASE */.id.ALLOW_REPURCHASE);
    var allowRepurchase = allowRepurchaseFF && user.isLoggedIn;
    var vendor = (0,use_vendor/* default */.Z)();
    var showCategoryFooterInHome = vendor === null || vendor === void 0 ? void 0 : (ref = vendor.settings) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : ref1.showCategoryFooterInHome;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* MainLayout */.Zn, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(banners, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4 flex w-full flex-col gap-4",
                children: [
                    allowRepurchase && /*#__PURE__*/ (0,jsx_runtime.jsx)(repurchase_section, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(featured_products_section, {}),
                    showCategoryFooterInHome && /*#__PURE__*/ (0,jsx_runtime.jsx)(categories_section, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(toggled_esm/* Flag */.WN, {
                flagQuery: constants/* flags.TG_QUOTE */.id.TG_QUOTE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tg_quote, {
                    style: {
                        marginTop: theme/* default.spacing.comfortable */.Z.spacing.comfortable
                    }
                })
            })
        ]
    });
}
/* harmony default export */ var home = (HomeScreen);

;// CONCATENATED MODULE: ./pages/index.tsx






function HomePage(props) {
    var metaInfo = props.metaInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, (0,_object_spread/* default */.Z)({}, metaInfo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home, {})
        ]
    });
}
HomePage.getInitialProps = function(context) {
    return {
        metaInfo: (0,utils/* getMetaInfo */.R7)(context)
    };
};
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 57299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useScrollRestoration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


function useScrollRestoration() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleRouteChangeStart = function() {
            sessionStorage.setItem("scrollPosition", String(window.scrollY));
        };
        var handleRouteChangeComplete = function() {
            var scrollPosition = sessionStorage.getItem("scrollPosition");
            if (scrollPosition) {
                window.scrollTo(0, parseInt(scrollPosition, 10));
            }
        };
        router.events.on("routeChangeStart", handleRouteChangeStart);
        router.events.on("routeChangeComplete", handleRouteChangeComplete);
        return function() {
            router.events.off("routeChangeStart", handleRouteChangeStart);
            router.events.off("routeChangeComplete", handleRouteChangeComplete);
        };
    }, [
        router
    ]);
}


/***/ }),

/***/ 27026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90512);



function Section(param) {
    var title = param.title, subtitle = param.subtitle, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-col", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                className: "mb-4 ml-4 lg:mb-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        className: "text-xl font-semibold",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: subtitle
                    })
                ]
            }),
            children
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Section);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [157,3409,6203,9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);